import { Box, IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
interface IProps {
  onEditClick: () => void;
  onDeleteClick: () => void;
}

const BankInfosTableRenderCellAction = ({
  onEditClick,
  onDeleteClick,
}: IProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Tooltip title="Modifica info bancarie">
        <IconButton onClick={onEditClick}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Cancellare info bancarie">
        <IconButton onClick={onDeleteClick}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default BankInfosTableRenderCellAction;
